import React from "react";
import { Button, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "../../../../../components/YhBox";
import { useEntityModel, BeOptModeEnum } from "../entityModel";



export const DataBox = () => {
    const {
        selectedRowKeys,
        drawerVisible,
        setOptMode,
        setDrawerVisible,
        syncData
    } = useEntityModel();
    const onEdit = () => {
        if (selectedRowKeys.length != 1) {
            message.error("请选择一条数据!")
        } else {
            setOptMode(BeOptModeEnum.EDIT);
            setDrawerVisible(!drawerVisible)
        }
    }
    const onAdd = () => {
            setOptMode(BeOptModeEnum.ADD);
            setDrawerVisible(!drawerVisible)
    }
    const action = <>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => onAdd()}
            >新增</Button>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要操作的数据");
                        return;
                    }
                    onEdit();
                }}
            >编辑</Button>
    </>

    return (
    <YhBox title="经营实体管理列表" action={action} style={{height:'calc(100vh - 200px)'}}>
        <DataTable />
    </YhBox>
)
}
